import { RootState } from '../../store';

export const getPermissionsSelector = (state: RootState) => state?.roleReducer?.permissions;
